/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RunbookId } from "../../commons/types/RunbookId";
import { RoutineType } from "./RoutineType";
export const CreateRoutineRequest = core.serialization.object({
    runbookId: RunbookId,
    name: core.serialization.string(),
    config: core.serialization.any(),
    ordinal: core.serialization.number(),
    type: RoutineType,
});
